import React, { Component } from 'react';
import { CircleSlider } from "react-circle-slider";
import Slider from 'react-rangeslider';
import 'react-rangeslider/lib/index.css';
import 'react-responsive-modal/styles.css';
import './custom.css';

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import "react-tabs/style/react-tabs.css";
import { displayConsole, sendRequest } from '../helper';
import { connect } from '../../base/redux';
import { translate } from '../../base/i18n';
import { sendData } from '../websocket';
import Settings from './settings';
import { getLocalParticipant } from '../../base/participants';

import cross from './img/cross.png';
import radioActive from './img/radioActive.png';
import radioInactive from './img/radioInactive.png';
import { FEATURE_CUSTOM_REDUX, FEATURE_CUSTOM_REDUX_V2 } from '../../customise/constant';
import { Checkbox } from '@atlaskit/checkbox';
// import { filterRemoteParticipant, PANNING_VAR, _ValidateIPaddress } from '../../customise/Utils';
import { getBaseConfig, PANNING_VAR, _ValidateIPaddress } from '../../customise/Utils';
import Modal, {
    ModalBody,
    ModalTransition,
    ModalHeader,
    ModalTitle,
    ModalFooter
} from '@atlaskit/modal-dialog';
import { messages } from '../../customise/welcome-dashboard/messages';
import { Translate } from '../language';
import Button from '@atlaskit/button';
import { setDelayPanning } from '../../customise/redux/tool-webjam/actions';
import { sendAnalytics } from '../../analytics';
import { setDelayLocalChange } from '../../customise/redux/tool-webjam-v2/actions';
import { AutoChangeCircleSlider } from '../../customise/custom/toolbar/recording-streaming';
import Radio from './icon-components/Radio';
import { SaveLog } from '../../customise/Utils'
import { ct } from '../../customise/constant-Utils';
import Dialog from '../../base/ui/components/web/Dialog';

let timeoutFader;

class Fxtabs extends Component {

    state = {
        usersArr: [],
        sliderReverbValue: 0,
        leftReverb: false,
        rightReverb: true,
        open: false,
        // selectedIndex: 0,
        selectedIndex: sessionStorage.getItem("selectedIndex") ? parseInt(sessionStorage.getItem("selectedIndex")) : 1,
        userIndex: 0,
        volumeDialog: {
            noPanning: false,
            volumePanning: false,
            delayPanning: false
        },
        selectedPrevPan: PANNING_VAR.NO_PANNING
    }

    componentDidMount() {
        const { usersData, selectedIndex, userIndex } = this.props;
        const { users } = usersData;

        this.setState({
            usersArr: users,
            sliderReverbValue: usersData.reverbLevel,
            leftReverb: usersData.leftReverb,
            rightReverb: !usersData.leftReverb,
            open: false,
            // selectedIndex: selectedIndex,
            selectedIndex: parseInt(sessionStorage.getItem("selectedIndex")),
            userIndex: userIndex,
        });

    }

    // componentDidUpdate(prevProps) {
    //     const { usersData } = this.props;

    //     if (prevProps.usersData !== usersData) {
    //         if (usersData != null) {
    //             const { users } = usersData;
    //             if (users) {
    //                 this.setState({ 
    //                     //usersArr: users, 
    //                     sliderReverbValue: usersData.reverbLevel,
    //                     leftReverb: usersData.leftReverb,
    //                     rightReverb: !usersData.leftReverb,
    //                 });
    //             }
    //         }
    //     }
    // }

    componentDidUpdate(prevProps) {
        const { delayPanning, usersData, isCirclePanChange, userIndex } = this.props;
        const { selectedPrevPan } = this.state

        if (prevProps.delayPanning != delayPanning) {
            this.setState({
                selectedPrevPan: prevProps.delayPanning
            })
        }
        if (prevProps.isCirclePanChange != isCirclePanChange) {
            const { usersArr } = this.state;
            usersArr[userIndex].panValue = 50;
            this.setState({
                usersArr: usersArr
            })
        }
    }

    componentWillUnmount() {
    }

    sendDataToSocket(message) {
        sendData(message);
    }

    onOpenModal = () => {
        // TO SELECT Audio Settings by default
        sessionStorage.setItem('tabSelected', 1);
        this.setState({ open: true });
        sendAnalytics({
            action: 'settings-popup',
            source: "FX pan/reverb",
            category: "webjam FX"
        });
    };

    onCloseModal = () => {
        this.setState({ open: false });
    };

    changeCircleSlider(value) {
        const { usersArr, selectedIndex, userIndex } = this.state;
        const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

        let jitsiModerator = false;
        if (getLocalParticipant.role == 'moderator') {
            if (recordingStarted == 1 || streamingStarted == 1) {
                jitsiModerator = true;
            }
        }

        usersArr[userIndex].panValue = value ? value : 0;
        this.setState({ usersArr: usersArr });

        const message = {
            action: {
                panValue: value,
                uniqueID: usersData.uniqueId,
                index: selectedIndex,
                ipAddress: roomorIpAddress,
                jitsiModerator
            },
            content: 'set-pan',
            isBroadcast: true,
            sender: 'mobile'
        };
        displayConsole('set-pan', message);

        let this_ = this;
        if (timeoutFader) {
            clearTimeout(timeoutFader);
        }
        timeoutFader = setTimeout(function () {

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------

            this_.sendDataToSocket(message);
        }, 1500);
    }

    changeSliderReverb(value) {
        const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

        let jitsiModerator = false;
        if (getLocalParticipant.role == 'moderator') {
            if (recordingStarted == 1 || streamingStarted == 1) {
                jitsiModerator = true;
            }
        }

        this.setState({
            sliderReverbValue: value,
        });

        const message = {
            action: {
                leftValue: this.state.leftReverb,
                reverbValue: value,
                uniqueID: usersData.uniqueId,
                ipAddress: roomorIpAddress,
                jitsiModerator
            },
            content: 'set-reverb',
            isBroadcast: true,
            sender: 'mobile'
        };
        displayConsole('set-reverb', message);

        let this_ = this;
        if (timeoutFader) {
            clearTimeout(timeoutFader);
        }
        timeoutFader = setTimeout(function () {

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------

            this_.sendDataToSocket(message);
        }, 1500)
    }

    changeReverbLeftRadio() {
        const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

        let jitsiModerator = false;
        if (getLocalParticipant.role == 'moderator') {
            if (recordingStarted == 1 || streamingStarted == 1) {
                jitsiModerator = true;
            }
        }

        this.setState({
            leftReverb: true,
            rightReverb: false
        });

        const message = {
            action: {
                leftValue: true,
                reverbValue: this.state.sliderReverbValue,
                uniqueID: usersData.uniqueId,
                ipAddress: roomorIpAddress,
                jitsiModerator
            },
            content: 'set-reverb',
            isBroadcast: true,
            sender: 'mobile'
        };
        displayConsole('set-reverb', message);

        let this_ = this;
        if (timeoutFader) {
            clearTimeout(timeoutFader);
        }
        timeoutFader = setTimeout(function () {

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------

            this_.sendDataToSocket(message);
        }, 1500)
        sendAnalytics({
            action: 'set-reverb',
            source: "FX",
            category: "webjam FX"
        });
    }

    changeReverbRigtRadio() {
        const { usersData, getLocalParticipant, roomorIpAddress, recordingStarted, streamingStarted } = this.props;

        let jitsiModerator = false;
        if (getLocalParticipant.role == 'moderator') {
            if (recordingStarted == 1 || streamingStarted == 1) {
                jitsiModerator = true;
            }
        }

        this.setState({
            rightReverb: true,
            leftReverb: false
        });

        const message = {
            action: {
                leftValue: false,
                reverbValue: this.state.sliderReverbValue,
                uniqueID: usersData.uniqueId,
                ipAddress: roomorIpAddress,
                jitsiModerator
            },
            content: 'set-reverb',
            isBroadcast: true,
            sender: 'mobile'
        };
        displayConsole('set-reverb', message);

        let this_ = this;
        if (timeoutFader) {
            clearTimeout(timeoutFader);
        }
        timeoutFader = setTimeout(function () {

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.uniqueID,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------

            this_.sendDataToSocket(message);
        }, 1500)
        sendAnalytics({
            action: 'set-reverb',
            source: "FX",
            category: "webjam FX"
        });
    }

    handleDelayPanning(type) {
        // When delay panning is enable or disable, also need to change the audio channel type as well, this in second "secondDataToSocket"
        const { usersData, delayPanning, roomorIpAddress } = this.props;
        if (delayPanning != undefined) {
            if (delayPanning == type) {
                return false;
            }
        }
        let prevVolState = {
            noPanning: false,
            volumePanning: false,
            delayPanning: false
        }
        if (type == PANNING_VAR.NO_PANNING) {
            prevVolState.noPanning = true;
        } else if (type == PANNING_VAR.VOLUME_PANNING) {
            if (usersData.audioChannel != 1) {
                prevVolState.volumePanning = true;
            }
        } else if (type == PANNING_VAR.DELAY_PANNING) {
            if (usersData.audioChannel != 1) {
                prevVolState.delayPanning = true;
            }
        }

        this.setState({
            volumeDialog: prevVolState
        })

        if (prevVolState.volumePanning == false && prevVolState.delayPanning == false) {
            this.sendPanning(type)
        }

        // this.sendDataToSocket(message);
    }

    sendPanning(type) {
        //console.log("received ", PANNING_VAR.DELAY_PANNING, "rrr  ", PANNING_VAR[type], "tye ", type)
        const { usersData, roomorIpAddress, getLocalParticipant, devicesUsers, dispatch, prevPanning } = this.props;
        let willMove = true;

        dispatch(setDelayLocalChange(true));

        setTimeout(function () {
            dispatch(setDelayLocalChange(false));
        }, 10000)


        if (type == PANNING_VAR.VOLUME_PANNING || type == PANNING_VAR.NO_PANNING) {
            if (!sessionStorage.getItem("c_" + roomorIpAddress)) {
                dispatch(setDelayPanning(type, {
                    isLocal: true
                }));
                willMove = false;

                let index;
                if (type == PANNING_VAR.VOLUME_PANNING) {
                    index = 1;
                }
                // else if (prevPanning.length > 1) {
                //     prevPanning.pop();
                //     index = prevPanning.pop();
                // } 
                else {
                    index = 0;
                }

                const message = {
                    // CUSTOM
                    action: {
                        uniqueID: usersData.uniqueId,
                        audioChannel: index,
                        panningName: type
                    },
                    // END
                    content: 'audio-channel',
                    isBroadcast: true,
                    sender: 'mobile'
                };

                //-------------Prepare logger data -------------
                var log_data = {
                    functionName: '',
                    triggeredBy: 'system',
                    event: message.content,
                    requestData: message,
                    responseData: '',
                    userId: '',
                    boxId: message.action.uniqueID,
                    message: 'Emit to server'
                }
                SaveLog(log_data);
                //-------------------------------------------

                sendData(message)

                sendAnalytics({
                    action: 'set-pan',
                    source: "FX",
                    category: "webjam FX"
                });
            }
        }

        if (willMove) {
            let uniqueId = "";
            if (type == PANNING_VAR.DELAY_PANNING) {
                sessionStorage.setItem("c_" + roomorIpAddress, 1)
                if (devicesUsers?.uniqueId) {
                    uniqueId = devicesUsers.uniqueId;
                } else if (usersData.uniqueId) {
                    uniqueId = usersData.uniqueId
                }
            } else {
                uniqueId = usersData.uniqueId
            }

            const message = {
                action: {
                    deviceId: uniqueId,
                    status: true,
                    room: roomorIpAddress,
                    panning_name: PANNING_VAR[type.toUpperCase()],
                    // name: getLocalParticipant.name || "RTA User",
                    // name: getLocalParticipant.name || "user",
                    name: getLocalParticipant.name || getBaseConfig("userName"),
                    jitsiId: getLocalParticipant.id
                },
                content: type == PANNING_VAR.DELAY_PANNING ? 'enable-delay-panning' : "disable-delay-panning",
                isBroadcast: true,
                sender: 'mobile'
            };

            //-------------Prepare logger data -------------
            var log_data = {
                functionName: '',
                triggeredBy: 'system',
                event: message.content,
                requestData: message,
                responseData: '',
                userId: '',
                boxId: message.action.deviceId,
                message: 'Emit to server'
            }
            SaveLog(log_data);
            //-------------------------------------------

            this.sendDataToSocket(message);
            sendAnalytics({
                action: 'set-pan',
                source: "FX",
                category: "webjam FX"
            });
        }

        // // change pan to 50%
        let _this = this;


        setTimeout(function () {
            const { usersArr, userIndex } = _this.state;
            usersArr[userIndex].panValue = 50;
            _this.setState({
                usersArr: usersArr
            })
        }, 2000)
    }

    volumePanningModal() {
        return (
            <ModalTransition>
                {/* <Modal onClose={() => this.closePanning({
                    volumePanning: false
                })}
                    testId={"volume-pan"}
                > */}
                <Dialog
                    disableAutoHideOnSubmit={true}
                    disableBackdropClose={true}
                    hideCloseButton={false}
                    onCancel={() => this.closePanning({
                        volumePanning: false
                    })}
                    onSubmit={() => {
                        this.sendPanning(PANNING_VAR.VOLUME_PANNING),
                            this.closePanning({
                                volumePanning: false
                            })
                    }}
                    testId="volume-pan"
                    zIndex={99999}
                    rtaClassName="volume-pan-modal-wrapper"
                    title={ct("rta-trmc.mixer.enableVolumePanning")}
                >
                    {/* <ModalHeader className="vol-pan-container">
                        <ModalTitle>
                            {ct("rta-trmc.mixer.enableVolumePanning")}
                        </ModalTitle>
                        <button
                            type="button"
                            style={{ color: "#fff" }}
                            className="c-button c-button--close"
                            onClick={() => this.closePanning({
                                volumePanning: false
                            })}>×</button>
                    </ModalHeader> */}
                    {/* <ModalBody> */}
                    <p style={{
                        padding: "10px 0",
                        color: "#000"
                    }}>{ct("Translate.messages.volumePanning")}</p>
                    {/* </ModalBody> */}
                    {/* <ModalFooter className="justify-content-between text-right">
                        <Button
                            id='submit-btn'
                            appearance="primary"
                            className="submit-button login-btn-pass join-meeting-pass"
                            onClick={() => {
                                this.sendPanning(PANNING_VAR.VOLUME_PANNING),
                                    this.closePanning({
                                        volumePanning: false
                                    })
                            }}>
                            {ct("Translate.buttonTitle.okCaps")}
                        </Button>
                        <Button
                            id='cancel-btn'
                            appearance="subtle"
                            onClick={() => this.closePanning({
                                volumePanning: false
                            })}>{ct("Translate.buttonTitle.cancelSmall")}</Button>
                    </ModalFooter> */}
                    {/* </Modal> */}
                </Dialog>
            </ModalTransition>
        )
    }

    delayPanningModal() {
        return (
            <ModalTransition>
                {/* <Modal onClose={() => this.closePanning({
                    delayPanning: false
                })}
                    testId={"delay-pan"}
                > */}
                <Dialog
                    disableAutoHideOnSubmit={true}
                    disableBackdropClose={true}
                    hideCloseButton={false}
                    onCancel={() => this.closePanning({
                        delayPanning: false
                    })}
                    onSubmit={() => {
                        this.sendPanning(PANNING_VAR.DELAY_PANNING),
                            this.closePanning({
                                delayPanning: false
                            })
                    }}
                    testId="volume-pan"
                    zIndex={99999}
                    rtaClassName="volume-pan-modal-wrapper"
                    title={ct("rta-trmc.mixer.enableDelayPanning")}
                >
                    {/* <ModalHeader className="vol-pan-container">
                        <ModalTitle>
                            {ct("rta-trmc.mixer.enableDelayPanning")}
                        </ModalTitle>
                        <button
                            type="button"
                            style={{ color: "#fff" }}
                            className="c-button c-button--close"
                            onClick={() => this.closePanning({
                                delayPanning: false
                            })}>×</button>
                    </ModalHeader>
                    <ModalBody> */}
                    <p style={{
                        padding: "10px 0",
                        color: "#000"
                    }}>
                        {ct("Translate.messages.delayPanning")}
                    </p>
                    {/* </ModalBody> */}
                    {/* <ModalFooter className="justify-content-between text-right">
                        <Button
                            id='submit-btn'
                            appearance="primary"
                            onClick={() => {
                                this.sendPanning(PANNING_VAR.DELAY_PANNING),
                                    this.closePanning({
                                        delayPanning: false
                                    })
                            }}
                            className="submit-button login-btn-pass join-meeting-pass"
                        >
                            {ct("Translate.buttonTitle.okCaps")}
                        </Button>
                        <Button
                            id='cancel-btn'
                            appearance="subtle"
                            onClick={() => this.closePanning({
                                delayPanning: false
                            })}>{ct("Translate.buttonTitle.cancelSmall")}</Button>
                    </ModalFooter> */}
                </Dialog>
                {/* </Modal> */}

            </ModalTransition>
        )
    }

    closePanning(type) {
        let prevVolS = Object.assign(this.state.volumeDialog, type)
        this.setState({
            volumeDialog: prevVolS
        })
    }


    render() {
        const { usersData, onClose, delayPanning, roomorIpAddress } = this.props;

        const { volumeDialog } = this.state;

        const {
            usersArr,
            open,
            sliderReverbValue,
            leftReverb,
            rightReverb,
            selectedIndex,
            userIndex
        } = this.state;


        return (
            <div className="modalSound">
                {volumeDialog.volumePanning && this.volumePanningModal()}
                {volumeDialog.delayPanning && this.delayPanningModal()}

                <div className="modal" id={open ? 'hide-fx-modal' : 'show-fx-modal'}>
                    <div className="modal-content">
                        <span id='cross-icon-wrapper' className="close" onClick={onClose}>
                            <img id='cross-icon-img' src={cross} />
                        </span>

                        {usersArr.length > 0 &&
                            <Tabs>
                                <TabList>
                                    <Tab>{ct("rta-trmc.mixer.pan")}</Tab>
                                    {usersArr[userIndex].name == 'me' || usersArr[userIndex].name == 'Me' || usersArr[userIndex].name == 'ME' ?
                                        <Tab>{ct("rta-trmc.mixer.reverb")}</Tab>
                                        : null}
                                </TabList>

                                <TabPanel>
                                    <div className="host-setting pan-block">
                                        {/* <div className="d-flex"> */}
                                        <div className={"d-flex mobile-in-height pan-block-ui"}>
                                            <div className="pab-ui-circle">
                                                <div className="pan-circle-place">
                                                    {usersData.audioChannel != 0 ?
                                                        // <span>
                                                        <span id="pan-circle-base">
                                                            <CircleSlider
                                                                value={usersArr[userIndex].panValue}
                                                                size={200}
                                                                knobRadius={12}
                                                                circleWidth={9}
                                                                progressWidth={10}
                                                                progressColor="#26ff28"
                                                                shadow={false}
                                                                onChange={(value) => { this.changeCircleSlider(value); }}
                                                            />
                                                        </span>
                                                        :
                                                        // <span>
                                                        <span id="pan-circle-base">
                                                            <CircleSlider
                                                                value={0}
                                                                size={200}
                                                                className="pan-circle-filled"
                                                                id="pan-circle-filled"
                                                                knobRadius={12}
                                                                circleWidth={9}
                                                                progressWidth={10}
                                                                shadow={false}
                                                                disabled={true}
                                                            />
                                                        </span>
                                                    }
                                                    <div className="circle-txt mt-2">
                                                        <div className="txt mr-3">L</div>
                                                        <div className="txt ml-3">R</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="pan-outer">
                                                <div className="pan-title">
                                                    <span className="f-lg d-block"> {ct("rta-trmc.mixer.pan")}: </span>
                                                    <p> {ct("rta-trmc.mixer.panEffectChange")} </p>
                                                </div>

                                                <button id='audio-settings-1' className="border-btn mt-4 px-5" onClick={this.onOpenModal}>
                                                    {ct("rta-trmc.mixer.goToSettings")}
                                                </button>
                                                {
                                                    // !_ValidateIPaddress(roomorIpAddress) &&
                                                    !_ValidateIPaddress(roomorIpAddress) && getBaseConfig("tools").includes("delayPanning") &&

                                                    <div className="delay-pan-contain">
                                                        <div className="setting-3" style={{ paddingTop: "20px" }}>
                                                            <div
                                                                className="radio d-flex align-items-start"
                                                            >
                                                                {/* <img src={delayPanning == PANNING_VAR.NO_PANNING.toLowerCase() ? radioActive : radioInactive}
                                                                    onClick={() => this.handleDelayPanning(PANNING_VAR.NO_PANNING)}
                                                                    style={{ cursor: "pointer" }}
                                                                /> */}
                                                                <span id='no-panning' onClick={() => this.handleDelayPanning(PANNING_VAR.NO_PANNING)}
                                                                    style={{ cursor: "pointer" }}>
                                                                    <Radio
                                                                        id={`no-panning`}
                                                                        active={delayPanning == PANNING_VAR.NO_PANNING.toLowerCase()}
                                                                    />
                                                                </span>
                                                                <label className="pl-3"
                                                                    style={{ marginBottom: "0" }}
                                                                >{ct("rta-trmc.mixer.noPanning")}</label>
                                                            </div>
                                                        </div>

                                                        <div className="setting-3" style={{ paddingTop: "10px" }}>
                                                            <div
                                                                className="radio d-flex align-items-start"
                                                            >
                                                                {/* <img src={delayPanning == PANNING_VAR.VOLUME_PANNING.toLowerCase() ? radioActive : radioInactive}
                                                                    onClick={() => this.handleDelayPanning(PANNING_VAR.VOLUME_PANNING)}
                                                                    style={{ cursor: "pointer" }}
                                                                /> */}
                                                                <span id='volume-panning' onClick={() => this.handleDelayPanning(PANNING_VAR.VOLUME_PANNING)}
                                                                    style={{ cursor: "pointer" }}>
                                                                    <Radio
                                                                        id={`volume-panning`}
                                                                        active={delayPanning == PANNING_VAR.VOLUME_PANNING.toLowerCase()}
                                                                    />
                                                                </span>
                                                                <label className="pl-3"
                                                                    style={{ marginBottom: "0", }}
                                                                >{ct("rta-trmc.mixer.volumePanning")}</label>
                                                            </div>
                                                        </div>
                                                        <div className="setting-3" style={{ paddingTop: "10px" }}>
                                                            <div
                                                                className="radio d-flex align-items-center"
                                                            >
                                                                {/* <img src={delayPanning == PANNING_VAR.DELAY_PANNING.toLowerCase() ? radioActive : radioInactive}
                                                                    onClick={() => this.handleDelayPanning(PANNING_VAR.DELAY_PANNING)}
                                                                    style={{ cursor: "pointer" }}
                                                                /> */}
                                                                <span id='delay-panning' onClick={() => this.handleDelayPanning(PANNING_VAR.DELAY_PANNING)}
                                                                    style={{ cursor: "pointer" }}>
                                                                    <Radio
                                                                        id={`delay-panning`}
                                                                        active={delayPanning == PANNING_VAR.DELAY_PANNING.toLowerCase()}
                                                                    />
                                                                </span>
                                                                <label className="pl-3"
                                                                    style={{ marginBottom: "0" }}
                                                                >{ct("rta-trmc.mixer.delayPanning")}</label>
                                                            </div>
                                                        </div>

                                                    </div>
                                                }

                                            </div>

                                        </div>
                                    </div>
                                </TabPanel>

                                {usersArr[userIndex].name == 'me' || usersArr[userIndex].name == 'Me' || usersArr[userIndex].name == 'ME' ?
                                    <TabPanel>
                                        <div className="host-setting p-4">
                                            <div>
                                                <label>{ct("rta-trmc.mixer.currentReverb")} </label>
                                            </div>
                                            {/* { hostTabData && hostTabData.length > 0 ? */}
                                            {/* <div className="d-flex mt-5"> */}
                                            <div className="d-flex mt-5 mobile-in-height PanTabwrapper">
                                                <div className="pan-col">
                                                    <div className="pan-area mr-0">
                                                        <div className="pan-title">
                                                            <div className="t1">{ct("rta-trmc.mixer.reverb")}</div>
                                                        </div>
                                                        <Slider
                                                            name='reverb'
                                                            min={0}
                                                            max={100}
                                                            value={sliderReverbValue}
                                                            className="right-slide-bar"
                                                            orientation='vertical'
                                                            onChange={(value) => { this.changeSliderReverb(value); }}
                                                        />
                                                    </div>
                                                    <div className="radio-place d-inline-block">
                                                        {usersData.audioChannel != 2 &&
                                                            <div className="radios align-self-end">
                                                                <div className="radio d-flex align-items-center my-3" value={leftReverb} onClick={() => this.changeReverbLeftRadio()} >
                                                                    {/* <img src={leftReverb ? radioActive : radioInactive} /> */}
                                                                    <Radio
                                                                        active={leftReverb}
                                                                    />
                                                                    <label className="pl-3 mb-0">{ct("rta-trmc.mixer.left")}</label>
                                                                </div>
                                                                <div className="radio d-flex align-items-center mt-3 mb-1" value={rightReverb} onClick={() => this.changeReverbRigtRadio()} >
                                                                    {/* <img src={rightReverb ? radioActive : radioInactive} /> */}
                                                                    <Radio
                                                                        active={rightReverb}
                                                                    />
                                                                    <label className="pl-3 mb-0">{ct("rta-trmc.mixer.right")}</label>
                                                                </div>
                                                            </div>
                                                        }
                                                    </div>
                                                </div>
                                                <div className="pan-txt">
                                                    <div>
                                                        <span className="f-lg mb-3 d-block"> {ct("rta-trmc.mixer.reverb")}: </span>
                                                        <p dangerouslySetInnerHTML={{ __html: ct("rta-trmc.mixer.reverbContent") }}></p>
                                                    </div>
                                                    <button id='audio-settings-2' className="border-btn px-5 mt-4" onClick={this.onOpenModal}>
                                                        {/* onClick={this.onOpenModal} */}
                                                        {ct("rta-trmc.mixer.goToSettings")}
                                                    </button>
                                                </div>
                                            </div>

                                            {/* :
                                        <div className="center-load-img">
                                            <span>Calculating...</span>
                                        </div>
                                        } */}

                                        </div>
                                    </TabPanel>
                                    : null}
                            </Tabs>
                        }
                    </div>
                </div>
                {open == true && <Settings onClose={this.onCloseModal} />}
            </div>
        )
    }
}

function _mapStateToProps(state) {
    return {
        usersData: state[FEATURE_CUSTOM_REDUX].usersData,
        delayPanning: state[FEATURE_CUSTOM_REDUX].delayPanning,
        prevPanning: state[FEATURE_CUSTOM_REDUX].prevPanning,
        getLocalParticipant: getLocalParticipant(state),
        roomorIpAddress: state[FEATURE_CUSTOM_REDUX].roomorIpAddress,
        recordingStarted: state[FEATURE_CUSTOM_REDUX].recordingStarted,
        streamingStarted: state[FEATURE_CUSTOM_REDUX].streamingStarted,
        isCirclePanChange: state[FEATURE_CUSTOM_REDUX_V2].isCirclePanChange
    };
}

export default translate(connect(_mapStateToProps)(Fxtabs));
